<template>
    <div @click="$emit('input', !value)" class="h-6 w-12 cursor-pointer select-none" :class="value ? 'bg-green-500' : 'bg-red-500'">
        <div class="h-4 w-4 bg-white m-1" :style="{ 'margin-left': value ? '1.75rem' : '0.25rem'}"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean
    }
}
</script>